// Sequência das etapas da avaliação por perfil do aluno.
// Fonte única usada pelo submenu (ordem das abas) e pelos modais de "próxima etapa",
// para que o fluxo oferecido ao final de cada etapa seja sempre o da aba seguinte.

export const ETAPAS_ADULTO = [
  { chave: 'Anamnese', nome: 'Anamnese', artigo: 'a' },
  { chave: 'ParQ', nome: 'ParQ', artigo: 'o' },
  { chave: 'Coronariano', nome: 'Risco Coronariano', artigo: 'o' },
  { chave: 'Antropometria', nome: 'Antropometria', artigo: 'a' },
  { chave: 'Composicao Corporal', nome: 'Composição Corporal', artigo: 'a' },
  { chave: 'Vo2', nome: 'VO2 máx', artigo: 'o' },
  { chave: 'PrescricaoTreinoAerobico', nome: 'Prescrição do Treinamento Aeróbico', artigo: 'a' },
  { chave: 'AvaliacaoNeuromuscular', nome: 'Avaliação Neuromuscular', artigo: 'a' },
  // Ocultada temporariamente do fluxo e do submenu (a pedido). Ao reativar, basta descomentar:
  // a Avaliação Neuromuscular volta a oferecê-la como próxima etapa automaticamente.
  // { chave: 'PrescricaoTreinoForca', nome: 'Prescrição do Treinamento de Força', artigo: 'a' },
];

export const ETAPAS_IDOSO = [
  { chave: 'Anamnese', nome: 'Anamnese', artigo: 'a' },
  { chave: 'CapFuncionalQuest', nome: 'Classificação Funcional', artigo: 'a' },
  { chave: 'TesteCapFunc', nome: 'Teste de Capacidade Funcional', artigo: 'o' },
  { chave: 'Katz', nome: 'Katz', artigo: 'o' },
  { chave: 'Lawton', nome: 'Lawton', artigo: 'o' },
  { chave: 'EscalaBeg', nome: 'Escala de Berg', artigo: 'a' },
  { chave: 'ParQ', nome: 'ParQ', artigo: 'o' },
  { chave: 'Coronariano', nome: 'Risco Coronariano', artigo: 'o' },
  { chave: 'AntropometriaIdosos', nome: 'Antropometria', artigo: 'a' },
  { chave: 'Composicao Corporal', nome: 'Composição Corporal', artigo: 'a' },
  { chave: 'Vo2', nome: 'VO2 máx', artigo: 'o' },
  { chave: 'PrescricaoTreinoAerobico', nome: 'Prescrição do Treinamento Aeróbico', artigo: 'a' },
  { chave: 'AvaliacaoNeuromuscular', nome: 'Avaliação Neuromuscular', artigo: 'a' },
];

export const ehPerfilIdoso = (perfil) => perfil === 'idosos';

export const etapasDoPerfil = (perfil) => (ehPerfilIdoso(perfil) ? ETAPAS_IDOSO : ETAPAS_ADULTO);

// Próxima etapa do fluxo; null quando a etapa atual é a última do perfil.
export const proximaEtapa = (perfil, chaveAtual) => {
  const etapas = etapasDoPerfil(perfil);
  const indice = etapas.findIndex((e) => e.chave === chaveAtual);
  if (indice < 0 || indice === etapas.length - 1) return null;
  return etapas[indice + 1];
};

export const textoProximaEtapa = (etapa) => (etapa ? `Deseja ir para ${etapa.artigo} ${etapa.nome}?` : '');
